<template>
  <div class="px-4">
    <TaskForm
      v-if="edit"
      :action="updateTask"
      :task="task"
      :member-options="memberOptions"
      @cancel="edit = false"
    />

    <TaskDeleteForm v-else-if="destroy" :task="task" @cancel="destroy = false" />

    <div v-else class="flex flex-col flex-1">
      <div class="text-xs mb-4">
        <div class="flex">
          <div class="text-gray-600">
            <template v-if="user"> {{ user.firstName }} {{ user.lastName }} </template>
            <template v-else> Unknown user </template>
            <template v-if="task.createdAtDiffForHumans">
              <span class="font-normal">&bull;</span>
              {{ task.createdAtDiffForHumans }}
            </template>
          </div>

          <div class="ml-auto">
            <a role="button" @click="editTask">edit</a>
            <span class="text-gray-600"> &bull; </span>
            <a role="button" @click="confirmDeleteTask">delete</a>
          </div>
        </div>

        <template v-if="task.dueAt">
          <div class="text-gray-600">
            <span class="font-normal">Due:</span>
            {{ dueDate }}
            <template v-if="dueTime">
              at <span class="font-bold">{{ dueTime }}</span>
            </template>
          </div>
        </template>
      </div>
      <div class="space-y-2">
        <p class="text-sm font-medium">
          {{ task.title }}
        </p>
        <div v-if="task.content" class="overflow-hidden leading-4 h-12 text-gray-600">
          {{ task.content }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import TaskForm from './TaskForm.vue';
import TaskDeleteForm from './TaskDeleteForm.vue';

export default {
  components: {
    TaskForm,
    TaskDeleteForm,
  },
  props: {
    task: {
      type: Object,
      required: true,
    },
    memberOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      edit: false,
      destroy: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.entities.users.byId[this.task.userId] || null;
    },
    dueDate() {
      if (!this.task.dueAt) return null;
      return moment(this.task.dueAt).format('DD MMMM YYYY');
    },
    dueTime() {
      if (!this.task.dueAt) {
        return null;
      }

      if (!this.task.hasTime) {
        return null;
      }

      return moment(this.task.dueAt).format('HH:mm');
    },
  },

  methods: {
    async updateTask(formData) {
      try {
        await this.$store.dispatch('ui/tasks/update', {
          taskUuid: this.task.uuid,
          formData,
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    editTask() {
      this.$emit('focusing');
      this.edit = true;
      this.destroy = false;
    },
    confirmDeleteTask() {
      this.$emit('focusing');
      this.destroy = true;
      this.edit = false;
    },
    blur() {
      this.edit = false;
      this.destroy = false;
    },
  },
};
</script>

<style scoped>
.clamp {
  line-clamp: 3;
  box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
